import { useCallback } from 'react';
import { ISubscriberFn, ISubscriberInfo } from '../types';
import { IGeneralSubscriberInfo } from '../constants/subscribeTypes';

export default function useSubscriptionClick({ subscribers, dataWidgetId, dataWidgetSport, dataWidgetCuid }: IGeneralSubscriberInfo) {
  return useCallback(
    (info: ISubscriberInfo, clickType: string) => {
      subscribers?.[clickType]?.forEach((fn: ISubscriberFn) =>
        fn({
          dataWidgetId,
          dataWidgetSport,
          clickType,
          info,
          dataWidgetCuid,
        }),
      );
    },
    [dataWidgetId, dataWidgetSport, subscribers, dataWidgetCuid],
  );
}
